<h1 mat-dialog-title class="text-xl font-medium">Dein kostenloser Testzeitraum ist abgelaufen</h1>
<mat-dialog-content>
    <p>
        Diese Organisation besitzt nur noch eine Free Lizenz und erlaubt somit keine Kollaboration mit mehreren Nutzern.
    </p>
    <p>
        Bitte kontaktiere den Ersteller dieser Organisation, damit dieser eine Pro oder Enterprise Lizenz erwerben kann.
    </p>
    <div class="mt-4 flex justify-end">
        <button mat-flat-button color="primary" (click)="signOut()">Abmelden</button>
    </div>
</mat-dialog-content>
